import iconArrowLefttLine from './arrow_left_line.svg';
import iconArrowRightLine from './arrow_right_line.svg';
import iconBox3Line from './box_3_line.svg';
import iconCheckCircleFill from './check_circle_fill.svg';
import iconChevronDownFill from './chevron_down_fill.svg';
import iconChevronLeftLine from './chevron_left_line.svg';
import iconChevronUpFill from './chevron_up_fill.svg';
import iconCopy from './copy_line.svg';
import iconArrowDownWhite from './down_line_white.svg';
import iconLayoutBottomOpenLine from './layout_bottom_open_line.svg';
import iconLayoutTopOpenLine from './layout_top_open_line.svg';
import iconLockLine from './lock_line.svg';
import iconPencil from './pencil_line.svg';
import iconCashbackPromos from './receive_money_line.svg';
import iconTimeLine from './time_line.svg';
import iconArrowUpWhite from './up_line_white.svg';
import iconUserFill from './user_4_fill.svg';
import iconGlobe from './world_2_line.svg';
;

export const icons = {
  arrowDownWhite: iconArrowDownWhite,
  arrowUpWhite: iconArrowUpWhite,
  arrowRightLine: iconArrowRightLine,
  arrowLeftLine: iconArrowLefttLine,
  cashbackPromos: iconCashbackPromos,
  chevronDownFill: iconChevronDownFill,
  chevronLeftLine: iconChevronLeftLine,
  chevronUpFill: iconChevronUpFill,
  copy: iconCopy,
  globe: iconGlobe,
  box3Line: iconBox3Line,
  lockLine: iconLockLine,
  layoutBottomOpenLine: iconLayoutBottomOpenLine,
  layoutTopOpenLine: iconLayoutTopOpenLine,
  userFill: iconUserFill,
  checkCircleFill: iconCheckCircleFill,
  pencil: iconPencil,
  timeLine: iconTimeLine,
};

export type IconName = keyof typeof icons;
